'use strict';

import React, { Component } from 'react'

import { CSSTransition } from 'react-transition-group'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import ColorForm from '@/Form/ColorForm'

const { app } = window;

export default class ECColorPage extends Component
{
	state = { };

	UNSAFE_componentWillMount  ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		var output =
		(
			<Layout page_title="Thème de couleur" history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ appear:500, enter: 240, exit: 320 }}>

								<ColorForm history={ props.history } />

							</CSSTransition>

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
